<template>
  <v-dialog @click:outside="close" v-model="isShow" width="700">
    <v-card>
      <v-card-title style="background: #7E69FF; color: white; padding: 12px; font-weight: bold">{{title}}</v-card-title>
      <v-card-text class="pa-0">
        <v-simple-table height="300" fixed-header class="more-homework-table" id="style-2">
          <template v-slot:default>
            <thead>
              <tr>
                <th style="min-width: 160px; max-width: 160px">Bài tập</th>
                <th style="min-width: 80px; max-width: 80px">Điểm</th>
                <th style="min-width: 160px; max-width: 160px">Thời gian làm bài</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(homework, index) in homeworks" :key="'homework' + index">
                <td><span class='text-format'>{{homework.name}}</span></td>
                <td>
                  <template v-if="courseFolderCode !== IELTS_CONVERSATION">
                    <div v-if="homework.status === 'Đã làm'" style="color: #0088FF">
                      <v-tooltip top>
                        <template v-slot:activator="{attrs, on}">
                          <div v-on="on" v-bind="attrs">
                            <a :href="homework.linkResult" style="text-decoration: none" target="_blank" v-if="homework.gradingScale !== 0 && !homework.gradingScale">
                              {{homework.correctQuestions || homework.totalCorrectQuestions}}/{{homework.totalQuestions}}
                            </a>
                            <div v-else @click="isSelfStudy ? handleRedirectHomeworkDetail(homework) : ''">
                              <a v-if="homework.gradingScale === 0">
                                {{homework.totalCorrectQuestions ? homework.totalCorrectQuestions : homework.correctQuestions}}/{{homework.totalQuestions}}
                              </a>
                              <a v-else-if="homework.gradingScale === 1">
                                {{homework.bandScore}}
                              </a>
                              <a v-else-if="homework.gradingScale === 2">
                                {{homework.hundredScore}}/100
                              </a>
                              <a v-else-if="homework.gradingScale === 4">
                                {{parseFloat((homework.totalCorrectQuestions ? homework.totalCorrectQuestions : homework.correctQuestions)/homework.totalQuestions).toFixed(2)}}
                              </a>
                            </div>
                          </div>
                        </template>
                        <div>{{
                            GRADING_SCALE[homework.gradingScale] || 'Số câu đúng/Tổng số câu'
                          }}</div>
                      </v-tooltip>
                    </div>
                    <a v-else @click="isSelfStudy ? handleRedirectHomeworkDetail(homework) : ''" style="color: #EB5501; font-weight: bold; text-decoration: none; font-size: 13px" :href="homework.linkPractice" target="_blank">
                      {{homework.status}}
                    </a>
                  </template>
                  <template v-else>
                    <span style="font-size: 14px !important; color: #0088FF;" v-if="homework.star !== null">
                      {{homework.star}}
                      <img src="../../../modules/student_care/assets/star-icon.svg" alt="">
                    </span>
                    <a v-else @click="isSelfStudy ? handleRedirectHomeworkDetail(homework) : ''" style="color: #EB5501; font-weight: bold; text-decoration: none" :href="homework.linkPractice" target="_blank">
                      {{homework.status}}
                    </a>
                  </template>
                </td>
                <td>
                  <div v-if="homework.time">
                    <span class='text-format'>{{formatDateCus(homework.time, 'DD/MM/YYYY HH:mm')}}</span>
                  </div>
                  <div v-else class="d-flex align-center" style="height: 100%">
                    <img src="../../../modules/student_care/assets/empty-data.svg" alt="">
                  </div>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
      <v-card-actions class=" d-flex justify-center">
        <v-btn color="#FF5555" style="color: white; border-radius: 16px" @click="close()">Đóng</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { GRADING_SCALE } from '@/modules/student_care/constant/constant';

const IELTS_CONVERSATION = 'IELTS_CONVERSATION';

export default {
  name: 'PopupShowMoreHomeworks',
  props: {
    courseFolderCode: {
      type: String,
      default: '',
    },
    isSelfStudy: {
      type: Boolean,
      default: false,
    },
    isShow: {
      type: Boolean,
      required: true,
    },
    homeworks: {
      type: Array,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      GRADING_SCALE,
      IELTS_CONVERSATION,
    };
  },
  methods: {
    handleRedirectHomeworkDetail(homework) {
      this.$emit('redirect-homework-detail', homework);
    },
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss">
.more-homework-table {
  thead {
    tr {
      th {
        color: black !important;
        font-weight: bold;
        font-size: 14px !important;
      }
    }
  }
}
</style>
<style scoped>
a, .text-format {
  font-family: Roboto;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
}
</style>
